import { render, staticRenderFns } from "./AddProfileDialog.vue?vue&type=template&id=71ff3275&scoped=true"
import script from "./AddProfileDialog.vue?vue&type=script&lang=js"
export * from "./AddProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./AddProfileDialog.vue?vue&type=style&index=0&id=71ff3275&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff3275",
  null
  
)

export default component.exports